export default {
  methods: {
    buildQuery() {
      return {
        userId: this.$store.state.shared.selectedUserId,
        projectId: this.$store.state.shared.projectId,
        showClosed: this.$store.state.shared.showClosed,
        filterBy: this.$store.state.tipping.filterBy,
        filterCol: this.$store.state.tipping.filterCol,
        filterBy2: this.$store.state.tipping.filterBy2,
        filterCol2: this.$store.state.tipping.filterCol2,
        filterStatus: this.$store.state.tipping.filterStatus,
        dateRangeStart: this.$store.state.shared.dateRangeStart,
        dateRangeEnd: this.$store.state.shared.dateRangeEnd,
        dateRangeToggle: this.$store.state.shared.dateRangeToggle
      }
    }
  }
}